import { CrossMark } from "../../Assets/Icons";

export default function CloseButton({ onClick, className = "", ariaLabel = "Close" }) {
  return (
    <button
      className={`close-button${className ? ` ${className}` : ""}`}
      onClick={onClick}
      type="button"
      aria-label={ariaLabel}
    >
      <CrossMark />
    </button>
  );
}
